import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { IDocument } from '../../Interfaces/IDocument';
import { DocumentDownloaded } from '../DocumentDownloaded';

interface IPropsDownloaded {
  open: boolean;
  onClose: () => void;
  localDocumentObject: IDocument;
}

export const DocumentDownloadedDialog: React.FC<IPropsDownloaded> = ({
  open,
  onClose,
  localDocumentObject,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogContent>
        <DocumentDownloaded documentObject={localDocumentObject} />
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onClose}>
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
